<script setup>
import { watch, defineProps, defineEmits, ref, computed} from "vue";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore";
import TabelaDeItens from "./Itens/TabelaDeItens.vue";
import TabelaDeParcelas from "./Parcelas/TabelaDeParcelas.vue";
import CartaoObservacoesGerais from "./ObservacoesGerais/CartaoObservacoesGerais.vue";
import CartaoFornecedor from "./Fornecedor/CartaoFornecedor.vue";
import PedidoDeCompraService from "../../api/v2/services/PedidoDeCompraService";
import UtilObject from "../../utils/UtilObject";
import UtilDateTime from "@/utils/UtilDateTime";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "aberto",
    "cotacoesItens",
    "fornecedores",
    "parcelasCondicoesDePagamento",
    "unidadesItens",
]);

const emits = defineEmits([
    "update:aberto"
]);

//==================================================================//
//================== Criar Pedido de Compra Modal ==================//
//==================================================================//

const dialogo = ref(null);

//==================================================================//
//================== Criar Pedido de Compra Modal ==================//
//==================================================================//

const modal = ref(null);

//==================================================================//
//======================= Colaborador Store ========================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 
const compradorNome = ref(colaboradorStore.colaborador.nome);

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const criandoPedido = ref(false);
const controlesDesativados = ref(false);

//==================================================================//
//=========================== Fornecedor ===========================//
//==================================================================//

const cartaoFornecedor = ref(null);
const fornecedores = ref(props.fornecedores);

const fornecedor = ref({});
const fornecedorVendedor = ref({});

//==================================================================//
//============================= Parcelas ===========================//
//==================================================================//

const tabelaDeParcelas = ref(null);
const parcelas = ref([]);
const parcelasCondicoesDePagamento = ref(props.parcelasCondicoesDePagamento);

//==================================================================//
//======================== Cotacoes Itens ==========================//
//==================================================================//

const tabelaDeItens = ref(null);
let cotacoesItens = ref(props.cotacoesItens);

//==================================================================//
//===================== Cartão Observações Gerais ==================//
//==================================================================//

const cartaoObservacoesGerais = ref(null);
const observacaoGeral = ref("");


//==================================================================//
//================= Aterna Controles Desativados ===================//
//==================================================================//

const alternaControlesDesativados = (valor) =>{

    controlesDesativados.value = valor;

};

//==================================================================//
//======================= Ao Alterar Fornecedor ====================//
//==================================================================//

const aoAlterarFornecedor = (fornecedorUpdate) =>{

    fornecedor.value = fornecedorUpdate;
    observacaoGeral.value = fornecedor?.value?.ultimaObservacao;
    fornecedorVendedor.value = {};

};

//==================================================================//
//================ Ao Alterar Fornecedor Vendedor ==================//
//==================================================================//

const aoAlterarFornecedorVendedor = (fornecedorVendedorUpdate) =>{

    fornecedorVendedor.value = fornecedorVendedorUpdate;

};

//==================================================================//
//============= Ao Alterar Fornecedor Ultima Observação ============//
//==================================================================//

const aoAlterarFornecedorUltimaObservacao = (update) =>{

    fornecedor.value.ultimaObservacao = update.ultimaObservacao;

};

//=================================================================//
//=========================== Altera Item =========================//
//=================================================================//

const alteraItem = (update)=>{

    let itemIndex = cotacoesItens.value.findIndex(({id}) => id == update.id);
    let item = cotacoesItens.value[itemIndex];
    let itemAlterado = UtilObject.deepMerge({...item}, update);

    cotacoesItens.value.splice(itemIndex,1,itemAlterado);

};

//=================================================================//
//========================== Altera Itens =========================//
//=================================================================//

const alteraItens = (update)=>{

    cotacoesItens.value.forEach((item,itemIndex)=>{

        let itemAlterado = UtilObject.deepMerge({...item}, update);

        cotacoesItens.value.splice(itemIndex,1,itemAlterado);

    });

};

//==================================================================//
//=================== Ao Alterar Observacao Geral ==================//
//==================================================================//

const aoAlterarObservacaoGeral = (update) =>{

    observacaoGeral.value = update.observacaoGeral;

};

//==================================================================//
//=================== Soma Itens Valor Total =======================//
//==================================================================//

const somaItensValorTotal = computed(() => {

    return cotacoesItens.value.reduce((acc,{osItemPrecoTotalComImpostosComIPI})=>{

        acc += osItemPrecoTotalComImpostosComIPI;
        return acc;

    },0);

});

//==================================================================//
//============================ Cancelar ============================//
//==================================================================//

const cancelar = () => {

    limpaModal();

    emits('update:aberto');

};

//==================================================================//
//============================== Criar =============================//
//==================================================================//

const criar = async () => {

    if(!validate()){
        return
    }

    criandoPedido.value = true;

    await criaPedidoDeCompra();

    limpaModal();

    emits('update:aberto');

    criandoPedido.value = false;

};

//==================================================================//
//============================== Criar =============================//
//==================================================================//

const criaPedidoDeCompra = async () => {
    
    let fornecedorId = fornecedor.value.id;
    let fornecedorVendedorId = fornecedorVendedor.value.id;
    let cotacoesItensIDs = cotacoesItens.value.map(({id})=>id);
    let parcelasValores = parcelas.value.map((parcela)=>{

        let descricao = parcela?.descricao?.descricao ? parcela?.descricao?.descricao : parcela?.descricao;

        return {
            tipo: parcela.tipo,
            descricao: descricao,
            diasVencimento: parcela.diasVencimento,
            dataEntrega: UtilDateTime.toFormatUTC({dateTime:parcela.dataEntrega}),
            dataVencimento: UtilDateTime.toFormatUTC({dateTime:parcela.dataVencimento}),
            percentual: parcela.percentual,
            valor: parcela.valor,
            referenciaEvento: parcela.referenciaEvento,
        }
    });
    let observacaoGeralValor = observacaoGeral.value;

    let pedidoDeCompraResponse = await PedidoDeCompraService.criarPedido(fornecedorId,fornecedorVendedorId,cotacoesItensIDs,parcelasValores,observacaoGeralValor);
    if(pedidoDeCompraResponse.status != 200){
        throw new Error("Falha ao criar o Pedido de Compra"); 
    }

}

//==================================================================//
//========================== Limpa Modal ===========================//
//==================================================================//

const limpaModal = () => {

    cartaoFornecedor.value.reset();
    fornecedor.value = {};
    fornecedorVendedor.value = {};

    cotacoesItens.value = [];
    parcelas.value = [];

    observacaoGeral.value = "";
    cartaoObservacoesGerais.value.reset();

};

//==================================================================//
//============================ Validate ============================//
//==================================================================//

const validate = () =>{

    // Valida o Fornecedor do Pedido 
    if(!cartaoFornecedor?.value?.validate()){
        scrollToComponent({component:cartaoFornecedor})
        return false;
    }

    // Valida os Itens do Pedido
    if(!tabelaDeItens?.value?.validate()){
        scrollToComponent({component:tabelaDeItens})
        return false;
    }

    // Valida as Parcelas do Pedido
    if(!tabelaDeParcelas?.value?.validate()){
        scrollToComponent({component:tabelaDeParcelas})
        return false;
    }

    // Valida a Observação Geral do Pedido
    if(!cartaoObservacoesGerais?.value?.validate()){
        scrollToComponent({component:cartaoObservacoesGerais})
        return false;
    }

    return true;

}

//==================================================================//
//========================= Scroll To ============================//
//==================================================================//

const scrollToComponent = (location) =>{

    let defaultOffSet = 110;

    let componenteQueVaiScrolar = dialogo?.value?.$refs?.dialog;
    let componenteScrolado = modal?.value.$el;
    let componenteParaIr = location?.component?.value?.$el;
    let componenteParaIrOffSet = location?.offSet || defaultOffSet

    let scrolarAte = (
        componenteParaIr.getBoundingClientRect().top -
        componenteScrolado.getBoundingClientRect().top -
        componenteParaIrOffSet
    );

    componenteQueVaiScrolar.scrollTo({
        behavior: 'smooth',
        top: scrolarAte
    });

};

//==================================================================//
//========================= Watch Aberto ===========================//
//==================================================================//
// Quando o Modal é Aberto for aberto, execute.

watch(()=> props.aberto, () => {

    if(props.aberto == false){
        return;
    }

    fornecedores.value = props.fornecedores;
    fornecedor.value = {};
    fornecedorVendedor.value = {};
    
    cotacoesItens.value = props.cotacoesItens;
    
    parcelasCondicoesDePagamento.value = props.parcelasCondicoesDePagamento;
    parcelas.value = [];
    
    observacaoGeral.value = "";

});

//==================================================================//
//============================ Watch ===============================//
//==================================================================//

watch(criandoPedido, (novoValor) => {

    alternaControlesDesativados(novoValor);

});

</script>

<template>

    <main>

        <v-dialog
            ref="dialogo"
            v-model="props.aberto"
            content-class="teste"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card
                ref="modal"
                class="c-modal"
                :class="{ 'c-main--disabled': controlesDesativados }"
            >

                <div
                    class="c-modal__barra c-barra"
                >

                    <v-btn
                        class="c-barra__botao-cancelar"
                        color="error"
                        dark
                        @click="cancelar"
                        :disabled="controlesDesativados"
                    >
                        Cancelar
                    </v-btn>

                    <p
                        class="c-barra__titulo"
                    >

                        <v-icon
                            color="white"
                            large
                        >
                            mdi-invoice-list-outline
                        </v-icon>

                        Novo Pedido de Compra
                    </p>

                    <v-btn
                        class="c-barra__botao-criar"
                        color="green"
                        dark
                        @click="criar"
                        :disabled="controlesDesativados"
                    >
                        Criar
                    </v-btn>

                    <v-chip
                        class="c-barra__comprador"
                        color="primary"
                        label
                    >

                        <v-icon left>
                            mdi-account-circle-outline
                        </v-icon>
                        Comprador:
                        {{compradorNome}}

                    </v-chip>

                    <v-chip
                        class="c-barra__itens-contador"
                        color="primary"
                        label
                    >

                        <v-icon left>
                            mdi-cube-outline
                        </v-icon>
                        Itens Selecionados:
                        {{props.cotacoesItens.length}}

                    </v-chip>
                    
                </div>

                <div
                    class="c-modal__conteudo"
                >
                    
                    <CartaoFornecedor
                        ref="cartaoFornecedor"
                        :aberto="aberto"
                        :fornecedores="fornecedores"
                        :fornecedor="fornecedor"
                        :fornecedorVendedor="fornecedorVendedor"
                        :controlesDesativados="controlesDesativados"
                        @update:fornecedor="aoAlterarFornecedor"
                        @update:fornecedorVendedor="aoAlterarFornecedorVendedor"
                    >
                    </CartaoFornecedor>

                    <TabelaDeItens
                        ref="tabelaDeItens"
                        :fornecedor="fornecedor"
                        :cotacoesItens="cotacoesItens"
                        :controlesDesativados="controlesDesativados"
                        :somaItensValorTotal="somaItensValorTotal"
                        :unidadesItens="unidadesItens"
                        @update:controlesDesativados="alternaControlesDesativados"
                        @update:item="alteraItem"
                        @update:itens="alteraItens"
                    >
                    </TabelaDeItens>

                    <TabelaDeParcelas
                        ref="tabelaDeParcelas"
                        :parcelas="parcelas"
                        :parcelasCondicoesDePagamento="parcelasCondicoesDePagamento"
                        :controlesDesativados="controlesDesativados"
                        :somaItensValorTotal="somaItensValorTotal"
                    ></TabelaDeParcelas>

                    <CartaoObservacoesGerais
                        ref="cartaoObservacoesGerais"
                        :fornecedor="fornecedor"
                        :observacaoGeral="observacaoGeral"
                        :controlesDesativados="controlesDesativados"
                        @update:observacaoGeral="aoAlterarObservacaoGeral"
                        @update:fornecedorUltimaObservacao="aoAlterarFornecedorUltimaObservacao"
                        @update:controlesDesativados="alternaControlesDesativados"
                    >
                    </CartaoObservacoesGerais>

                </div>

            </v-card>
            
        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-modal_barra{
    display: initial;
    padding: 0 0 5px 0 !important;
}

.c-barra{
    display: grid;
    position: sticky;
    z-index: 1;
    top: 0;
    grid-template-columns: min-content 1fr min-content;
    grid-template-rows: 1fr 1fr;
    grid-template-areas: 
    "botaoCancelar titulo botaoCriar"
    "comprador comprador itensContador";
    align-items: center;
    gap: 10px;
    padding: 6px 16px !important;
    margin: 0px 0 4px 0px !important;
    color: #FFFFFF;
    border-color: #230bc1 !important;
    background-color: #230bc1 !important;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-barra__botao-cancelar{
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
}

.c-barra__botao-cancelar {
     grid-area: botaoCancelar;
}

.c-barra__titulo{
    grid-area: titulo;
    font-size: 1.25rem !important;
    font-weight: 500 !important;
    margin: auto;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-barra__botao-criar{
    background-color: #4CAF50 !important;
    border-color: #4CAF50 !important;
}

.c-barra__botao-criar { 
    grid-area: botaoCriar;
}

.c-barra__comprador { 
    grid-area: comprador;
    width: fit-content;
}

.c-barra__itens-contador { 
    grid-area: itensContador;
}

.c-modal__conteudo{
    display: grid;
    gap:15px;
    padding: 12px;
}

</style>